(() => {
  const roots = document.querySelectorAll('[data-llp40-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.llp40Ready === 'true') return;
    root.dataset.llp40Ready = 'true';

    const productImage = root.dataset.image;
    const targetPouches = 2;
    const variantId = root.dataset.variant40 || '';
    const price = root.dataset.price40 || '$19.90';
    const specialPackPrices = {
      'travel-kit': '$34.90',
      'whole-home-starter': '$38.50',
      'travel-essentials': '$12.90',
      'pet-home-cleaning': '$34.90'
    };

    const products = {
      'laundry-scented': { name: 'Laundry Scented', amount: '20 sheets', variantId: '43780230807640' },
      'laundry-unscented': { name: 'Laundry Unscented', amount: '20 sheets', variantId: '44339267698776' },
      dish: { name: 'Dish Sheets', amount: '20 sheets', variantId: '44336338075736' },
      toilet: { name: 'Toilet Sheets', amount: '20 sheets', variantId: '44337142005848' },
      surface: { name: 'Surface Sheets', amount: '20 sheets', variantId: '44341343912024' },
      floor: { name: 'Floor Sheets', amount: '20 sheets', variantId: '44341354397784' },
      dryer: { name: 'Dryer Sheets', amount: '20 sheets', variantId: '44341355741272' },
      softener: { name: 'Colour Sheets', amount: '10 sheets' },
      colour: { name: 'Colour Guard', amount: '20 sheets', variantId: '44341346992216' },
      'pet-laundry': { name: 'Pet Laundry Unscented', amount: '20 sheets', variantId: '68031223201880' },
      'machine-cleaner': { name: 'Washing Machine Cleaner', amount: '5 tablets', variantId: '68031219990616' },
      stain: { name: 'Stain Wipe', amount: '10 pieces', variantId: '44341461090392' },
      sponge: { name: 'Magic Sponge', amount: '3 pieces' }
    };

    const presets = {
      'laundry-system-scented': ['laundry-scented', 'dryer', 'softener'],
      'laundry-system-unscented': ['laundry-unscented', 'dryer', 'softener'],
      'kitchen-reset': ['dish', 'surface', 'sponge'],
      'bathroom-refresh': ['toilet', 'surface', 'sponge'],
      'apartment-starter': ['laundry-scented', 'dish'],
      'student-starter': ['laundry-scented', 'dish', 'surface'],
      'easy-care': ['laundry-unscented', 'dish'],
      'busy-family': ['laundry-scented', 'dish', 'sponge', 'toilet'],
      'travel-kit': ['laundry-scented', 'dish', 'stain', 'towel', 'organiser'],
      'whole-home-starter': ['laundry-scented', 'dish', 'toilet', 'surface', 'floor', 'sponge']
    };

    const productDetails = {
      'laundry-scented-40': {
        name: 'Laundry Scented',
        amount: '40 sheets',
        points: 'No bottle · Pre-measured · Cold/warm',
        url: 'https://www.loadless.com.au/products/loadless-laundry-sheets-scented?variant=43780230807640'
      },
      'laundry-scented': {
        name: 'Laundry Scented',
        amount: '20 sheets',
        points: 'No bottle · Pre-measured · Cold/warm',
        url: 'https://www.loadless.com.au/products/loadless-laundry-sheets-scented?variant=43780230807640'
      },
      'laundry-unscented': {
        name: 'Laundry Unscented',
        amount: '20 sheets',
        travelAmount: '10 sheets',
        points: 'No bottle · Pre-measured · Cold/warm',
        url: 'https://www.loadless.com.au/products/loadless-laundry-sheet-unscented?variant=43778030043224'
      },
      dish: {
        name: 'Dish Sheets',
        amount: '20 sheets',
        travelAmount: '10 sheets',
        points: 'No bottle · Easy dose · Small spaces',
        url: 'https://www.loadless.com.au/products/loadless-dish-sheets-dishwasher-detergent?variant=43791268216920'
      },
      'dish-40': {
        name: 'Dish Sheets',
        amount: '40 sheets',
        points: 'No bottle · Easy dose · Small spaces',
        url: 'https://www.loadless.com.au/products/loadless-dish-sheets-dishwasher-detergent?variant=43791268216920'
      },
      toilet: {
        name: 'Toilet Sheets',
        amount: '20 sheets',
        travelAmount: '5 sheets',
        points: 'Drop in · Brush clean · Easy storage',
        url: 'https://www.loadless.com.au/products/loadless-bathroom-sheets-toilet-cleaner?variant=43780228120664'
      },
      surface: {
        name: 'Surface Sheets',
        amount: '20 sheets',
        points: 'No spray · Daily wipe · Easy storage',
        url: 'https://www.loadless.com.au/products/surface-care-sheets?variant=43840825131096'
      },
      floor: {
        name: 'Floor Sheets',
        amount: '20 sheets',
        points: 'Mop-ready · Daily residue · Barefoot rooms',
        url: 'https://www.loadless.com.au/products/loadless-floor-sheets?variant=43791269691480'
      },
      dryer: {
        name: 'Dryer Sheets',
        amount: '20 sheets',
        points: 'Dryer-ready · Less cling · Fresh feel',
        url: 'https://www.loadless.com.au/products/loadless-dryer-sheets?variant=43780231790680'
      },
      softener: {
        name: 'Colour Sheets',
        amount: '10 sheets',
        points: 'Easy add-in · Loose dye · Brightness support',
        url: 'https://www.loadless.com.au/products/loadless-colour-absorber-colour-protection?variant=43780231856216'
      },
      colour: {
        name: 'Colour Guard',
        amount: '20 sheets',
        points: 'Easy add-in · Loose dye · Brightness support',
        url: 'https://www.loadless.com.au/products/loadless-colour-absorber-colour-protection?variant=43780231856216'
      },
      'pet-laundry': {
        name: 'Pet Laundry Unscented',
        amount: '20 sheets',
        points: 'No added fragrance · Pet bedding and blankets · Easy dosing',
        url: 'https://www.loadless.com.au/products/pet-laundry-unscented?variant=67735221829720'
      },
      'machine-cleaner': {
        name: 'Washing Machine Cleaner',
        amount: '5 tablets',
        points: 'Helps remove build-up · No added fragrance · Routine machine care',
        url: 'https://www.loadless.com.au/products/washing-machine-cleaner?variant=67736123146328'
      },
      stain: {
        name: 'Stain Wipe',
        amount: '20 pieces',
        travelAmount: '5 pieces',
        points: 'Lift fresh stains · Clean on the go · Individually wrapped',
        url: 'https://www.loadless.com.au/products/loadless-fabric-stain-wiper?variant=43780225040472'
      },
      sponge: {
        name: 'Magic Sponge',
        amount: '3 pieces',
        points: 'Water-ready · Easy grip · Travel clean-up',
        url: 'https://www.loadless.com.au/products/magic-sponge?variant=44337214685272'
      },
      'sponge-bonus': {
        name: 'Launch bonus Magic Sponge',
        amount: '1 pack, 3 pieces',
        points: 'Water-ready · Easy grip · Travel clean-up',
        url: 'https://www.loadless.com.au/products/magic-sponge?variant=44337214685272'
      },
      towel: {
        name: 'CoolPress Towel',
        amount: '6 towels',
        points: 'Fresh cooling feel · Individually sealed · Travel-ready format',
        url: 'https://www.loadless.com.au/products/coolpress_towel?variant=44337215635544'
      },
      organiser: {
        name: 'Canvas Organiser',
        amount: '2 bags',
        points: '24×17×6cm · Easy refill · Sheet storage',
        url: 'https://www.loadless.com.au/products/canvas-organiser?variant=44337233363032',
        image: 'https://cdn.shopify.com/s/files/1/0702/1844/8984/files/canvasclear.webp?v=1790656245'
      },
      'essentials-laundry': { name: 'Laundry Scented', amount: '10 sheets', points: '', url: 'https://www.loadless.com.au/products/loadless-laundry-sheets-scented?variant=43780230807640' },
      'essentials-stain': { name: 'Stain Wipe', amount: '5 wipes · individually wrapped', points: '', url: 'https://www.loadless.com.au/products/loadless-fabric-stain-wiper?variant=43780225040472' },
      'travel-essentials-product': {
        name: 'Travel Essentials',
        amount: '10 scented laundry sheets · 5 individually wrapped stain wipes',
        points: 'Machine wash or handwash · Treat fresh stains on the spot · Compact for travel',
        image: 'https://cdn.shopify.com/s/files/1/0702/1844/8984/files/travelessentialclear.webp?v=1792498889',
        url: 'https://www.loadless.com.au/products/travel-essentials?variant=67808968802392'
      },
      'pet-kit-laundry': {
        name: 'Pet Laundry Unscented', amount: '20 sheets',
        points: '',
        url: 'https://www.loadless.com.au/products/pet-laundry-unscented?variant=67735221829720'
      },
      'pet-kit-machine': {
        name: 'Washing Machine Cleaner', amount: '10 tablets',
        points: '',
        url: 'https://www.loadless.com.au/products/washing-machine-cleaner?variant=67736123146328'
      },
      'pet-kit-stain': {
        name: 'Stain Wipe', amount: '20 wipes · individually wrapped',
        points: '',
        url: 'https://www.loadless.com.au/products/loadless-fabric-stain-wiper?variant=43780225040472'
      },
      'pet-kit-organiser': {
        name: 'Canvas Organiser', amount: '1 organiser', points: '',
        image: 'https://cdn.shopify.com/s/files/1/0702/1844/8984/files/canvasclear.webp?v=1790656245',
        url: 'https://www.loadless.com.au/products/canvas-organiser?variant=44337233363032'
      },
      'pet-home-cleaning-product': {
        name: 'Pet Home Cleaning Kit',
        amount: '20 laundry sheets · 10 machine cleaner tablets · 20 individually packed stain wipes · 1 organiser',
        points: 'No added fragrance for pet laundry · Helps remove machine build-up · Fresh stain care',
        image: 'https://cdn.shopify.com/s/files/1/0702/1844/8984/files/loadless-pet-home-cleaning-kit-product-pack.webp?v=1792971948',
        url: 'https://www.loadless.com.au/products/pet-home-cleaning-kit?variant=67726841184344'
      },
      'organiser-three': {
        name: 'Organiser',
        amount: '3 organisers',
        points: 'Sheet storage · Easy refill · Smooth zip',
        url: 'https://www.loadless.com.au/products/canvas-organiser?variant=44337233363032',
        image: 'https://cdn.shopify.com/s/files/1/0702/1844/8984/files/canvasclear.webp?v=1790656245'
      }
    };

    const detailBundles = {
      'laundry-scented': {
        title: 'Laundry Scented',
        subtitle: 'High-efficiency · Multi-enzyme · Washer-ready',
        products: ['laundry-scented'],
        cta: 'SELECT POUCH',
        selectProduct: 'laundry-scented'
      },
      'laundry-unscented': {
        title: 'Laundry Unscented',
        subtitle: 'High-efficiency · Fragrance-free · Washer-ready',
        products: ['laundry-unscented'],
        cta: 'SELECT POUCH',
        selectProduct: 'laundry-unscented'
      },
      dish: {
        title: 'Dish Sheets',
        subtitle: 'Hand/machine · Grease release · Clean rinse',
        products: ['dish'],
        cta: 'SELECT POUCH',
        selectProduct: 'dish'
      },
      toilet: {
        title: 'Toilet Sheets',
        subtitle: 'Fast dispersion · Bowl clean · One-sheet dose',
        products: ['toilet'],
        cta: 'SELECT POUCH',
        selectProduct: 'toilet'
      },
      surface: {
        title: 'Surface Sheets',
        subtitle: 'Grease film · Fast dissolve · Clean wipe',
        products: ['surface'],
        cta: 'SELECT POUCH',
        selectProduct: 'surface'
      },
      floor: {
        title: 'Floor Sheets',
        subtitle: 'Dilutable · Sealed floors · Low-film',
        products: ['floor'],
        cta: 'SELECT POUCH',
        selectProduct: 'floor'
      },
      dryer: {
        title: 'Dryer Sheets',
        subtitle: 'Heat-activated · Static control · Soft finish',
        products: ['dryer'],
        cta: 'SELECT POUCH',
        selectProduct: 'dryer'
      },
      colour: {
        title: 'Colour Guard',
        subtitle: 'Dye capture · Mixed loads · Colour care',
        products: ['colour'],
        cta: 'SELECT POUCH',
        selectProduct: 'colour'
      },
      'pet-laundry': {
        title: 'Pet Laundry Unscented',
        subtitle: 'No added fragrance · Washable pet fabrics · Easy dosing',
        products: ['pet-laundry'],
        cta: 'SELECT POUCH',
        selectProduct: 'pet-laundry'
      },
      'machine-cleaner': {
        title: 'Washing Machine Cleaner',
        subtitle: 'Helps remove build-up · No added fragrance · Machine care',
        products: ['machine-cleaner'],
        cta: 'SELECT POUCH',
        selectProduct: 'machine-cleaner'
      },
      stain: {
        title: 'Stain Wipe',
        subtitle: 'Fresh marks · Targeted wipe · Pre-wash',
        products: ['stain'],
        cta: 'SELECT POUCH',
        selectProduct: 'stain'
      },
      'laundry-system-scented': {
        title: 'Scented system',
        subtitle: 'Fresh finish · Pre-measured · Easy laundry',
        products: ['laundry-scented', 'dryer', 'softener'],
        cta: 'SELECT SYSTEM',
        variantId: '43846989938776',
        bundleUrl: 'https://www.loadless.com.au/products/laundry-system?variant=43846989938776'
      },
      'laundry-system-unscented': {
        title: 'Unscented system',
        subtitle: 'Clean finish · Pre-measured · Easy laundry',
        products: ['laundry-unscented', 'dryer', 'softener'],
        cta: 'SELECT SYSTEM',
        variantId: '44337213014104',
        bundleUrl: 'https://www.loadless.com.au/products/laundry-system-unscented-1?variant=44337213014104'
      },
      'kitchen-reset': {
        title: 'Kitchen reset',
        subtitle: 'Grease release · Clean rinse · Daily wipe',
        products: ['dish', 'surface', 'sponge'],
        cta: 'SELECT SYSTEM',
        variantId: '44338559189080',
        bundleUrl: 'https://www.loadless.com.au/products/kitchen-reset-system-1?variant=44338559189080'
      },
      'bathroom-refresh': {
        title: 'Bathroom refresh',
        subtitle: 'Bowl clean · Surface care · Easy dose',
        products: ['toilet', 'surface', 'sponge'],
        cta: 'SELECT SYSTEM',
        variantId: '44338553356376',
        bundleUrl: 'https://www.loadless.com.au/products/bathroom-refresh-system-1?variant=44338553356376'
      },
      'apartment-starter': {
        title: 'Apartment starter',
        subtitle: 'Laundry ready · Kitchen clean · Compact refill',
        products: ['laundry-scented', 'dish'],
        cta: 'SELECT PACK',
        variantId: '43900344860760',
        bundleUrl: 'https://www.loadless.com.au/products/apartment-home?variant=43900344860760'
      },
      'student-starter': {
        title: 'Student starter',
        subtitle: 'Fresh wash · Dish care · Surface clean',
        products: ['laundry-scented', 'dish', 'surface'],
        cta: 'SELECT PACK',
        variantId: '43846958612568',
        bundleUrl: 'https://www.loadless.com.au/products/student-starter?variant=43846958612568'
      },
      'easy-care': {
        title: 'Easy care',
        subtitle: 'Gentle wash · Colour care · Simple routine',
        products: ['laundry-unscented', 'dish'],
        cta: 'SELECT PACK',
        variantId: '44338774278232',
        bundleUrl: 'https://www.loadless.com.au/products/easy-care-1?variant=44338774278232'
      },
      'busy-family': {
        title: 'Busy family',
        subtitle: 'Fresh wash · Dish care · Bathroom ready',
        products: ['laundry-scented', 'dish', 'sponge', 'toilet'],
        cta: 'SELECT PACK',
        variantId: '43846955794520',
        bundleUrl: 'https://www.loadless.com.au/products/busy-family?variant=43846955794520'
      },
      'travel-kit': {
        title: 'Travel Pack',
        subtitle: '$34.90 delivered',
        products: ['laundry-scented', 'dish', 'stain', 'towel', 'organiser'],
        cta: 'SELECT PACK',
        selectSpecialPack: 'travel-kit',
        layout: 'travel',
        variantId: '43847060324440',
        bundleUrl: 'https://www.loadless.com.au/products/transit-pack?variant=43847060324440'
      },
      'travel-essentials': {
        title: 'Travel Essentials',
        subtitle: 'Laundry & stain care, wherever you go · $12.90 delivered',
        products: ['essentials-laundry', 'essentials-stain'],
        layout: 'travel',
        cta: 'SELECT PACK',
        selectSpecialPack: 'travel-essentials',
        specialPrice: '$12.90',
        variantId: '67808968802392',
        bundleUrl: 'https://www.loadless.com.au/products/travel-essentials?variant=67808968802392'
      },
      'pet-home-cleaning': {
        title: 'Pet Home Cleaning Kit',
        subtitle: 'For their mess. And your peace of mind. · $34.90 delivered',
        products: ['pet-kit-laundry', 'pet-kit-machine', 'pet-kit-stain', 'pet-kit-organiser'],
        layout: 'travel',
        cta: 'SELECT PACK',
        selectSpecialPack: 'pet-home-cleaning',
        specialPrice: '$34.90',
        variantId: '67726841184344',
        bundleUrl: 'https://www.loadless.com.au/products/pet-home-cleaning-kit?variant=67726841184344'
      },
      'whole-home-starter': {
        title: 'Whole Home Starter Pack',
        subtitle: '$38.50 delivered',
        products: ['laundry-scented-40', 'dish-40', 'toilet', 'surface', 'floor', 'organiser-three', 'sponge-bonus'],
        cta: 'SELECT PACK',
        selectSpecialPack: 'whole-home-starter',
        layout: 'travel',
        specialPrice: '$38.50',
        variantId: '44338628362328',
        bundleUrl: 'https://www.loadless.com.au/products/whole-home-starter-pack?variant=44338628362328'
      }
    };

    let selected = [];
    let activePreset = '';
    let isSubmittingCart = false;

    const packAmountOverrides = {
      'laundry-system-scented': {
        dryer: '10 sheets',
        softener: '10 sheets'
      },
      'laundry-system-unscented': {
        dryer: '10 sheets',
        softener: '10 sheets'
      },
      'kitchen-reset': {
        surface: '10 sheets'
      },
      'bathroom-refresh': {
        surface: '10 sheets'
      },
      'student-starter': {
        dish: '10 sheets',
        surface: '10 sheets'
      },
      'busy-family': {
        dish: '10 sheets',
        toilet: '5 sheets'
      },
      'travel-kit': {
        dish: '10 sheets',
        stain: '10 wipes · individually wrapped',
        organiser: '1 organiser'
      },
      'whole-home-starter': {
        surface: '10 sheets',
        floor: '10 sheets'
      }
    };

    const tabButtons = Array.from(root.querySelectorAll('[data-llp40-tab-button]'));
    const tabPanels = Array.from(root.querySelectorAll('[data-llp40-tab-panel]'));
    const cards = Array.from(root.querySelectorAll('[data-llp40-card]'));
    const addButtons = Array.from(root.querySelectorAll('[data-llp40-add]'));
    const presetCards = Array.from(root.querySelectorAll('[data-llp40-preset]'));
    const horizontalScrollers = Array.from(root.querySelectorAll('[data-llp40-scroll-area]'));
    const scrollButtons = Array.from(root.querySelectorAll('[data-llp40-scroll-button]'));

    const slotsEl = root.querySelector('[data-llp40-slots]');
    const progressEl = root.querySelector('[data-llp40-progress]');
    const countEls = root.querySelectorAll('[data-llp40-count], [data-llp40-mobile-count], [data-llp40-sticky-count]');
    const priceEl = root.querySelector('[data-llp40-price]');
    const stickyPriceEl = root.querySelector('[data-llp40-sticky-price]');
    const submitButtons = root.querySelectorAll('[data-llp40-submit], [data-llp40-sticky-submit]');
    const changeEl = root.querySelector('[data-llp40-change]');
    const startOverEls = root.querySelectorAll('[data-llp40-start-over]');
    const mobilePack = root.querySelector('[data-llp40-mobile-pack]');
    const mobileItems = root.querySelector('[data-llp40-mobile-items]');
    const detail = root.querySelector('[data-llp40-detail]');
    const detailSheet = detail ? detail.querySelector('.llp40v2-detail__sheet') : null;
    // Wider Whole Home Starter popup on desktop only; never alter mobile or other packs.
    if (!document.getElementById('llp40v2-whole-home-desktop-style')) {
      const style = document.createElement('style');
      style.id = 'llp40v2-whole-home-desktop-style';
      style.textContent = `@media (min-width: 990px) {
        .llp40v2-detail__sheet.llp40v2-whole-home-wide {
          width: min(96vw, 1660px) !important;
          max-width: min(96vw, 1660px) !important;
        }
        /* Centre every component and image; scale only the requested pack components. */
        /* Centre the complete two/four-product group, not just images inside left-aligned grid tracks. */
        .llp40v2-detail__products.llp40v2-centred-components {
          display: flex !important;
          flex-wrap: nowrap !important;
          justify-content: center !important;
          align-items: flex-start !important;
          gap: 28px !important;
          width: 100% !important;
        }
        .llp40v2-detail__products.llp40v2-centred-components .llp40v2-detail__product {
          flex: 0 1 245px !important;
          min-width: 0 !important;
          text-align: center !important;
        }
        .llp40v2-detail__products.llp40v2-centred-components .llp40v2-detail__plus {
          flex: 0 0 auto !important;
          align-self: center !important;
        }
        .llp40v2-detail__product { text-align: center !important; }
        .llp40v2-detail__product img { display: block !important; margin-left: auto !important; margin-right: auto !important; object-fit: contain !important; }
        .llp40v2-detail__sheet.llp40v2-large-pack-pouches .llp40v2-detail__product img {
          width: 160px !important; height: 190px !important; max-width: 100% !important;
        }
        .llp40v2-detail__sheet.llp40v2-whole-home-wide .llp40v2-detail__product img {
          width: 135px !important; height: 170px !important; max-width: 100% !important;
        }
        .llp40__ready-card[data-llp40-preset="travel-kit"] img,
        .llp40__ready-card[data-llp40-preset="pet-home-cleaning"] img {
          transform: scale(1.15) !important;
          transform-origin: center center !important;
          transition: transform .25s ease !important;
        }
        .llp40__ready-card[data-llp40-preset="travel-kit"] img:hover,
        .llp40__ready-card[data-llp40-preset="pet-home-cleaning"] img:hover {
          transform: translateY(-7px) scale(1.2) !important;
        }
      }`;
      document.head.appendChild(style);
    }

    const detailTriggers = Array.from(root.querySelectorAll('[data-llp40-detail-trigger]'));
    const detailContent = root.querySelector('[data-llp40-detail-content]');
    const detailTitle = root.querySelector('[data-llp40-detail-title]');
    const detailSubtitle = root.querySelector('[data-llp40-detail-subtitle]');
    const detailProducts = root.querySelector('[data-llp40-detail-products]');
    const detailSelect = root.querySelector('[data-llp40-detail-select]');

    const form = root.querySelector('[data-llp40-form]');
    const variantInput = root.querySelector('[data-llp40-variant-input]');
    const propSize = root.querySelector('[data-llp40-prop-size]');
    const propSelection = root.querySelector('[data-llp40-prop-selection]');
    const propNote = root.querySelector('[data-llp40-prop-note]');
    let detailTimer = 0;
    let detailPreviousFocus = null;
    let activeDetailKey = 'laundry-system-scented';
    const detailRestoreKey = `llp40:v2:detail-open:${window.location.pathname}`;

    const escapeHtml = (value) => {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const isTravelLayoutBundle = (key) => {
      const bundle = detailBundles[key];
      return Boolean(bundle && (key === 'travel-kit' || bundle.layout === 'travel'));
    };

    const getActiveSpecialBundle = () => {
      const bundle = detailBundles[activePreset];
      return bundle && bundle.selectSpecialPack ? bundle : null;
    };

    const isTravelKitSelected = () => Boolean(getActiveSpecialBundle());

    const getProductDetail = (key, bundleKey = '') => {
      const item = productDetails[key];
      if (!item) return null;

      const packAmount = packAmountOverrides[bundleKey] && packAmountOverrides[bundleKey][key];
      if (packAmount) {
        return {
          ...item,
          amount: packAmount
        };
      }

      if (bundleKey === 'travel-kit' && item.travelAmount) {
        return {
          ...item,
          amount: item.travelAmount
        };
      }

      return item;
    };

    const getSelectedProduct = (key) => {
      const product = products[key];
      if (!product) return null;

      const packAmount = packAmountOverrides[activePreset] && packAmountOverrides[activePreset][key];
      if (!packAmount) return product;

      return {
        ...product,
        amount: packAmount
      };
    };

    const getTravelKitItems = () => {
      const bundle = getActiveSpecialBundle() || detailBundles['travel-kit'];
      if (!bundle) return [];

      return bundle.products
        .map((key) => getProductDetail(key, activePreset || 'travel-kit'))
        .filter(Boolean);
    };

    const getPackTarget = () => {
      if (isTravelKitSelected()) return getTravelKitItems().length || targetPouches;

      const preset = presets[activePreset];
      return preset && preset.length ? preset.length : Math.max(targetPouches, selected.length);
    };

    const getSelectedCount = () => {
      if (isTravelKitSelected()) return getPackTarget();

      return selected.length;
    };

    const getRemainingPouches = () => Math.max(0, getPackTarget() - getSelectedCount());

    const buildTravelKitText = () => {
      return getTravelKitItems()
        .map((item) => `${item.name} (${item.amount})`)
        .join('; ');
    };

    const getActiveSpecialTitle = () => {
      const bundle = getActiveSpecialBundle();
      return bundle ? bundle.title : 'Travel Pack';
    };

    const getActiveSpecialPrice = () => {
      const bundle = getActiveSpecialBundle();
      if (!bundle) return price;
      return bundle.specialPrice || specialPackPrices[activePreset] || price;
    };

    const selectionSignature = (items) => {
      return items.slice().sort().join('|');
    };

    const isSameSelection = (items) => {
      return items.length > 0 && selectionSignature(items) === selectionSignature(selected);
    };

    const buildSelectionText = () => {
      if (packAmountOverrides[activePreset]) {
        return selected
          .map((key) => getSelectedProduct(key))
          .filter(Boolean)
          .map((item) => `${item.name} (${item.amount})`)
          .join('; ');
      }

      const grouped = selected.reduce((acc, key) => {
        const product = getSelectedProduct(key);
        if (!product) return acc;

        if (!acc[key]) {
          acc[key] = {
            name: product.name,
            count: 0
          };
        }

        acc[key].count += 1;
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((key) => {
          const item = grouped[key];
          return `${item.name} x ${item.count}`;
        })
        .join('; ');
    };

    const getCtaText = () => {
      if (isTravelKitSelected()) return 'ADD TO CART';
      const remaining = getRemainingPouches();
      if (remaining === 0) return 'ADD TO CART';
      if (remaining === 1) return 'Choose 1 more pouch';
      return 'Choose 2 pouches';
    };

    const getStickyCtaText = () => {
      if (isTravelKitSelected()) return 'ADD TO CART';
      const remaining = getRemainingPouches();
      if (remaining === 0) return 'ADD TO CART';
      if (remaining === 1) return 'Choose 1 more';
      return 'Choose 2 pouches';
    };

    const getCartItems = () => {
      const activeBundle = detailBundles[activePreset];

      if (activeBundle && activeBundle.variantId) {
        return [{ id: Number(activeBundle.variantId), quantity: 1 }];
      }

      const grouped = selected.reduce((acc, key) => {
        const product = products[key];
        if (!product || !product.variantId) return acc;

        acc[product.variantId] = (acc[product.variantId] || 0) + 1;
        return acc;
      }, {});

      return Object.keys(grouped).map((id) => ({
        id: Number(id),
        quantity: grouped[id]
      }));
    };

    const setSubmitting = (isSubmitting) => {
      isSubmittingCart = isSubmitting;
      submitButtons.forEach((button) => {
        button.setAttribute('aria-disabled', isSubmitting ? 'true' : 'false');
        button.classList.toggle('is-loading', isSubmitting);
        button.textContent = isSubmitting ? 'Adding...' : (button.hasAttribute('data-llp40-sticky-submit') ? getStickyCtaText() : getCtaText());
      });
    };

    const addCurrentSelectionToCart = async () => {
      if (isSubmittingCart) return;

      const items = getCartItems();
      if (!items.length) {
        scrollToOptions();
        return;
      }

      setSubmitting(true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Unable to add selection to cart.');
        }

        window.location.href = '/cart';
      } catch (error) {
        setSubmitting(false);
        window.alert(error.message || 'Unable to add selection to cart.');
      }
    };

    const setTab = (name) => {
      tabButtons.forEach((button) => {
        const isActive = button.dataset.llp40TabButton === name;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabPanels.forEach((panel) => {
        panel.hidden = panel.dataset.llp40TabPanel !== name;
      });

      window.requestAnimationFrame(updateScrollNav);
    };

    const getScrollArea = (name) => {
      return root.querySelector(`[data-llp40-scroll-area="${name}"]`);
    };

    const getScrollAmount = (area) => {
      const card = area.querySelector('.llp40__product, .llp40__ready-card');
      if (!card) return Math.max(220, area.clientWidth * 0.8);

      const styles = window.getComputedStyle(area);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateScrollNav = () => {
      scrollButtons.forEach((button) => {
        const area = getScrollArea(button.dataset.llp40ScrollTarget);
        const direction = button.dataset.llp40ScrollButton;

        if (!area) return;

        const maxScroll = Math.max(0, area.scrollWidth - area.clientWidth);
        if (area.scrollLeft < 0) area.scrollLeft = 0;
        if (area.scrollLeft > maxScroll) area.scrollLeft = maxScroll;

        const atStart = area.scrollLeft <= 2;
        const atEnd = area.scrollLeft >= maxScroll - 2;
        const isDisabled = maxScroll <= 2 || (direction === 'prev' && atStart) || (direction === 'next' && atEnd);

        button.disabled = isDisabled;
        button.classList.toggle('is-disabled', isDisabled);
        button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      });
    };

    const scrollAreaByButton = (button) => {
      const area = getScrollArea(button.dataset.llp40ScrollTarget);
      if (!area) return;

      const maxScroll = Math.max(0, area.scrollWidth - area.clientWidth);
      const direction = button.dataset.llp40ScrollButton === 'prev' ? -1 : 1;
      const atStart = area.scrollLeft <= 2;
      const atEnd = area.scrollLeft >= maxScroll - 2;

      if (maxScroll <= 2 || button.disabled || button.classList.contains('is-disabled')) {
        updateScrollNav();
        return;
      }

      if (direction < 0 && atStart) {
        area.scrollLeft = 0;
        updateScrollNav();
        return;
      }

      if (direction > 0 && atEnd) {
        area.scrollLeft = maxScroll;
        updateScrollNav();
        return;
      }

      const targetLeft = Math.min(
        maxScroll,
        Math.max(0, area.scrollLeft + direction * getScrollAmount(area))
      );

      area.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });

      window.setTimeout(updateScrollNav, 260);
    };

    const scrollToOptions = () => {
      const target = root.querySelector('.llp40__tabs');
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };

    const rememberDetailOpen = () => {
      try {
        window.sessionStorage.setItem(detailRestoreKey, activeDetailKey);
      } catch (error) {
        // sessionStorage can be unavailable in strict privacy modes.
      }
    };

    const forgetDetailOpen = () => {
      try {
        window.sessionStorage.removeItem(detailRestoreKey);
      } catch (error) {
        // sessionStorage can be unavailable in strict privacy modes.
      }
    };

    const getRestoredDetailKey = () => {
      try {
        const storedKey = window.sessionStorage.getItem(detailRestoreKey);
        return detailBundles[storedKey] ? storedKey : '';
      } catch (error) {
        return '';
      }
    };

    const updateDetailNext = () => {
      if (!detailProducts || !detailContent) return;

      const nextButton = detailContent.querySelector('[data-llp40-detail-next]');
      if (!nextButton) return;

      const maxScroll = Math.max(0, detailProducts.scrollWidth - detailProducts.clientWidth);
      const isDisabled = maxScroll <= 2 || detailProducts.scrollLeft >= maxScroll - 2;

      nextButton.disabled = isDisabled;
      nextButton.classList.toggle('is-disabled', isDisabled);
      nextButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    };

    const formatDetailPoints = (points, resolvedKey) => {
      if (!isTravelLayoutBundle(resolvedKey)) return escapeHtml(points);

      return String(points)
        .split('·')
        .map((point) => point.trim())
        .filter(Boolean)
        .map((point) => `<span class="llp40v2-detail__point">${escapeHtml(point)}</span>`)
        .join(' ');
    };

    const renderDetail = (detailKey) => {
      const resolvedKey = detailBundles[detailKey] ? detailKey : 'laundry-system-scented';
      const bundle = detailBundles[resolvedKey];
      if (!bundle || !detailTitle || !detailSubtitle || !detailProducts) return;
      const usesTravelLayout = isTravelLayoutBundle(resolvedKey);
      const usesSystemBundleLayout = !usesTravelLayout && bundle.products.length > 2;
      const isThreeProductSystem = usesSystemBundleLayout && bundle.products.length <= 3;
      const isFourProductSystem = usesSystemBundleLayout && bundle.products.length > 3;
      const isHorizontalSystem = isThreeProductSystem || isFourProductSystem;
      const isWholeHomeStarter = resolvedKey === 'whole-home-starter';
      // Desktop-only presentation; keep every other popup and mobile unchanged.
      if (detailSheet) {
        detailSheet.classList.toggle('llp40v2-whole-home-wide', isWholeHomeStarter);
        detailSheet.classList.toggle('llp40v2-large-pack-pouches', ['travel-kit', 'pet-home-cleaning', 'travel-essentials'].includes(resolvedKey));
      }

      activeDetailKey = resolvedKey;
      detailTitle.textContent = isWholeHomeStarter && window.matchMedia('(max-width: 989px)').matches
        ? 'Whole Home Starter'
        : bundle.title;
      detailSubtitle.textContent = bundle.subtitle;
      // Keep the pack-level link separate from the subtitle so it remains visible.
      const previousPackLink = detailSubtitle.parentElement.querySelector('[data-llp40-full-pack-link]');
      if (previousPackLink) previousPackLink.remove();
      if (bundle.bundleUrl || bundle.bundleSearchUrl) {
        const fullPackLink = document.createElement('a');
        fullPackLink.setAttribute('data-llp40-full-pack-link', '');
        fullPackLink.href = bundle.bundleUrl || bundle.bundleSearchUrl;
        fullPackLink.textContent = bundle.bundleUrl ? 'View pack details' : 'Find pack details';
        fullPackLink.style.cssText = 'display:block;width:max-content;max-width:100%;margin:10px auto 0;color:#111;font-size:14px;line-height:1.4;font-weight:400;text-decoration:underline;text-underline-offset:3px;';
        detailSubtitle.insertAdjacentElement('afterend', fullPackLink);
      }
      detailProducts.classList.toggle('is-list', bundle.products.length > 2);
      detailProducts.classList.toggle('is-single', bundle.products.length === 1);
      detailProducts.classList.toggle('is-travel', usesTravelLayout);
      detailProducts.classList.toggle('is-whole-home', isWholeHomeStarter);
      detailProducts.classList.toggle('llp40v2-centred-components', ['travel-essentials', 'pet-home-cleaning'].includes(resolvedKey));
      detailProducts.classList.toggle('is-system-three', isThreeProductSystem);
      detailProducts.classList.toggle('is-system-four', isFourProductSystem);

      if (detailSheet) {
        detailSheet.classList.toggle('is-single', bundle.products.length === 1);
        detailSheet.classList.toggle('is-travel', usesTravelLayout);
        detailSheet.classList.toggle('is-system-three', isThreeProductSystem);
        detailSheet.classList.toggle('is-system-four', isFourProductSystem);
      }

      if (detailContent) {
        detailContent.classList.toggle('is-scrollable', Boolean(bundle.scrollable));
        detailContent.classList.toggle('is-travel', usesTravelLayout);
        detailContent.classList.toggle('is-whole-home', isWholeHomeStarter);
        detailContent.classList.toggle('is-system-three', isThreeProductSystem);
        detailContent.classList.toggle('is-system-four', isFourProductSystem);
      }

      if (detailSelect) {
        detailSelect.textContent = bundle.cta || 'SELECT SYSTEM';
      }

      if (detailContent) {
        detailContent.querySelectorAll('[data-llp40-detail-next]').forEach((button) => {
          button.remove();
        });
      }

      const productMarkup = bundle.products.map((key, index) => {
        const item = getProductDetail(key, resolvedKey);
        if (!item) return '';
        const itemImage = item.image || productImage;

        const isSimplifiedReadyPack = ['travel-kit', 'travel-essentials', 'pet-home-cleaning'].includes(resolvedKey);
        // Individual product links are available in every multi-product pack,
        // including the four simplified packs. Keep their descriptions suppressed.
        const detailLink = item.url && bundle.products.length > 1
          ? `<a href="${escapeHtml(item.url)}">Details</a>`
          : (!isSimplifiedReadyPack && !isWholeHomeStarter && item.url
            ? `<a href="${escapeHtml(item.url)}">Details</a>`
            : '');
        const productCard = `
          <article class="llp40v2-detail__product">
            <img src="${escapeHtml(itemImage)}" alt="${escapeHtml(item.name)}">
            ${bundle.products.length === 1 && (resolvedKey === 'travel-essentials' || resolvedKey === 'pet-home-cleaning') ? '' : `<h3>${escapeHtml(item.name)}</h3>`}
            <p>${escapeHtml(item.amount)}</p>
            ${isSimplifiedReadyPack || isWholeHomeStarter || bundle.products.length === 1 ? '' : `<span>${formatDetailPoints(item.points, resolvedKey)}</span>`}
            ${detailLink}
          </article>
        `;

        if (bundle.products.length > 2 || index >= bundle.products.length - 1) {
          return productCard;
        }

        return `${productCard}<span class="llp40v2-detail__plus" aria-hidden="true">+</span>`;
      }).join('');

      detailProducts.innerHTML = productMarkup;

      if (usesTravelLayout || isHorizontalSystem) {
        detailProducts.insertAdjacentHTML(
          'afterend',
          '<button type="button" class="llp40v2-detail__next" aria-label="Show more products" data-llp40-detail-next>›</button>'
        );
      }

      detailProducts.scrollLeft = 0;
      window.requestAnimationFrame(updateDetailNext);
    };

    const openDetail = (detailKey = activeDetailKey) => {
      if (!detail) return;

      renderDetail(detailKey);
      window.clearTimeout(detailTimer);
      detailPreviousFocus = document.activeElement;
      detail.hidden = false;

      window.requestAnimationFrame(() => {
        detail.classList.add('is-open');
      });
    };

    const closeDetail = () => {
      if (!detail || detail.hidden) return;

      forgetDetailOpen();
      detail.classList.remove('is-open');
      detailTimer = window.setTimeout(() => {
        detail.hidden = true;

        if (detailPreviousFocus && typeof detailPreviousFocus.focus === 'function') {
          detailPreviousFocus.focus({ preventScroll: true });
        }
      }, 430);
    };

    const restoreDetailIfNeeded = () => {
      const restoredKey = getRestoredDetailKey();
      if (!detail || !restoredKey) return;

      window.requestAnimationFrame(() => {
        openDetail(restoredKey);
      });
    };

    const addProduct = (key) => {
      if (!products[key]) return;
      const selectedCount = selected.filter((item) => item === key).length;

      if (selectedCount >= targetPouches) return;

      if (selected.length >= targetPouches) return;

      activePreset = '';
      selected.push(key);
      update();
    };

    const removeProduct = (index) => {
      selected.splice(index, 1);
      activePreset = '';
      update();
    };

    const removeProductByKey = (key) => {
      const nextSelected = selected.filter((item) => item !== key);
      if (nextSelected.length === selected.length) return;

      selected = nextSelected;
      activePreset = '';
      update();
    };

    const usePreset = (presetKey) => {
      const preset = presets[presetKey] || [];
      if (preset.length < targetPouches) return;

      selected = [...preset];
      activePreset = presetKey;
      update();
    };

    const selectSpecialPack = (packKey = 'travel-kit') => {
      selected = [];
      activePreset = packKey;
      update();
    };

    const selectTravelKit = () => {
      selectSpecialPack('travel-kit');
    };

    const clearPreset = () => {
      selected = [];
      activePreset = '';
      update();
    };

    const togglePreset = (presetKey) => {
      const preset = presets[presetKey] || [];
      if (activePreset === presetKey && detailBundles[presetKey]?.selectSpecialPack) {
        clearPreset();
        return;
      }
      if (preset.length < targetPouches) return;

      if (activePreset === presetKey || isSameSelection(preset)) {
        clearPreset();
        return;
      }

      usePreset(presetKey);
    };

    const renderSlots = () => {
      if (!slotsEl) return;

      slotsEl.innerHTML = '';

      if (isTravelKitSelected()) {
        getTravelKitItems().forEach((item, index) => {
          const slot = document.createElement('div');
          const itemImage = item.image || productImage;
          slot.className = 'llp40__slot llp40__slot--kit';
          slot.innerHTML = `
            <span class="llp40__slot-number">${index + 1}</span>
            <img src="${escapeHtml(itemImage)}" alt="">
            <div>
              <strong>${item.name}</strong>
              <p>${item.amount}</p>
            </div>
          `;
          slotsEl.appendChild(slot);
        });
        return;
      }

      const slotCount = Math.max(getPackTarget(), selected.length);

      for (let index = 0; index < slotCount; index += 1) {
        const key = selected[index];
        const product = key ? getSelectedProduct(key) : null;
        const slot = document.createElement('div');

        slot.className = key ? 'llp40__slot' : 'llp40__slot is-empty';

        if (key) {
          slot.innerHTML = `
            <span class="llp40__slot-number">${index + 1}</span>
            <img src="${productImage}" alt="">
            <div>
              <strong>${product.name}</strong>
              <p>${product.amount || '20 sheets'}</p>
            </div>
            <button type="button" aria-label="Remove ${product.name}" data-llp40-remove="${index}">×</button>
          `;
        } else {
          slot.innerHTML = `
            <span class="llp40__slot-number">${index + 1}</span>
            <div>
              <strong>Pouch ${index + 1}</strong>
              <p>Choose a pouch</p>
            </div>
          `;
        }

        slotsEl.appendChild(slot);
      }
    };

    const renderMobilePack = () => {
      if (!mobilePack || !mobileItems) return;

      mobilePack.hidden = selected.length === 0 && !isTravelKitSelected();
      mobileItems.innerHTML = '';

      if (isTravelKitSelected()) {
        getTravelKitItems().forEach((item) => {
          const row = document.createElement('div');
          const itemImage = item.image || productImage;
          row.className = 'llp40__mobile-pack-item llp40__mobile-pack-item--kit';
          row.innerHTML = `
            <img src="${escapeHtml(itemImage)}" alt="">
            <div>
              <strong>${item.name}</strong>
              <p>${item.amount}</p>
            </div>
          `;
          mobileItems.appendChild(row);
        });
        return;
      }

      selected.forEach((key, index) => {
        const product = getSelectedProduct(key);
        if (!product) return;
        const row = document.createElement('div');

        row.className = 'llp40__mobile-pack-item';
        row.innerHTML = `
          <img src="${productImage}" alt="">
          <div>
            <strong>${product.name}</strong>
            <p>${product.amount || '20 sheets'}</p>
          </div>
          <button type="button" aria-label="Remove ${product.name}" data-llp40-remove="${index}">×</button>
        `;

        mobileItems.appendChild(row);
      });
    };

    const updateProductCards = () => {
      const remaining = getRemainingPouches();

      cards.forEach((card) => {
        const key = card.dataset.llp40Card;
        const selectedCount = selected.filter((item) => item === key).length;
        const button = card.querySelector('[data-llp40-add]');
        const check = card.querySelector('[data-llp40-card-remove]');

        card.classList.toggle('is-selected', selectedCount > 0);

        if (button) {
          button.disabled = remaining === 0 && selectedCount === 0;
          if (selectedCount === 0) {
            button.textContent = 'SELECT';
          } else {
            button.textContent = 'ADDED';
          }
          button.setAttribute('aria-pressed', selectedCount > 0 ? 'true' : 'false');
        }

        if (check) {
          const product = products[key];
          check.hidden = selectedCount === 0;
          check.textContent = selectedCount;
          check.setAttribute('aria-label', `Remove ${product.name} from pack`);
        }
      });
    };

    const updatePresetCards = () => {
      presetCards.forEach((card) => {
        const presetKey = card.dataset.llp40Preset;
        const preset = presets[presetKey] || [];
        const isActive = activePreset === presetKey || isSameSelection(preset);
        const button = card.querySelector('[data-llp40-preset-select]');
        const check = card.querySelector('[data-llp40-preset-toggle]');

        card.classList.toggle('is-active', isActive);

        if (button) {
          button.textContent = isActive ? 'ADDED' : 'SELECT';
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }

        if (check) {
          check.hidden = !isActive;
        }
      });
    };

    const updateForm = () => {
      if (variantInput) {
        variantInput.value = variantId;
      }

      if (propSize) {
        propSize.value = isTravelKitSelected() ? getActiveSpecialTitle() : '40 sheets';
      }

      if (propSelection) {
        propSelection.value = isTravelKitSelected() ? buildTravelKitText() : buildSelectionText();
      }

      if (propNote) {
        propNote.value = isTravelKitSelected() ? `${getActiveSpecialTitle()}: ${buildTravelKitText()}` : buildSelectionText();
      }
    };

    function update() {
      const packTarget = getPackTarget();
      const selectedCount = getSelectedCount();
      const complete = selectedCount >= packTarget;
      const progress = Math.min(100, (selectedCount / packTarget) * 100);
      const countText = `${selectedCount} / ${packTarget} pouches`;
      const mobileCountText = countText;
      const displayPrice = isTravelKitSelected() ? getActiveSpecialPrice() : (selected.length === 2 && selected.every((key) => key === 'stain') ? '$24.90' : price);

      countEls.forEach((el) => {
        el.textContent = el.hasAttribute('data-llp40-count') ? countText : mobileCountText;
      });

      if (progressEl) {
        progressEl.style.width = `${isTravelKitSelected() ? 100 : progress}%`;
      }

      if (priceEl) {
        priceEl.textContent = displayPrice;
      }

      if (stickyPriceEl) {
        stickyPriceEl.textContent = displayPrice;
      }

      submitButtons.forEach((button) => {
        button.textContent = button.hasAttribute('data-llp40-sticky-submit') ? getStickyCtaText() : getCtaText();
        button.classList.toggle('is-ready', complete);
      });

      if (changeEl) {
        changeEl.hidden = !selected.length && !isTravelKitSelected();
      }

      startOverEls.forEach((button) => {
        const hasSelection = Boolean(selected.length || isTravelKitSelected());
        const isDesktopReset = button.classList.contains('llp40__start-over--desktop');

        button.hidden = !isDesktopReset && !hasSelection;
        button.disabled = !hasSelection;
        button.classList.toggle('is-disabled', !hasSelection);
        button.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');
      });

      renderSlots();
      renderMobilePack();
      updateProductCards();
      updatePresetCards();
      updateForm();
      updateScrollNav();
    }

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTab(button.dataset.llp40TabButton);
      });
    });

    addButtons.forEach((button) => {
      button.addEventListener('click', () => {
        addProduct(button.dataset.llp40Add);
      });
    });

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('button, a')) return;

        const detailKey = card.dataset.llp40Card;
        if (!detailBundles[detailKey]) return;

        openDetail(detailKey);
      });
    });

    detailTriggers.forEach((trigger) => {
      const detailKey = trigger.dataset.llp40DetailTrigger;
      const bundle = detailBundles[detailKey];
      if (!bundle) return;

      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', `Open ${bundle.title} details`);

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openDetail(detailKey);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        event.stopPropagation();
        openDetail(detailKey);
      });
    });

    presetCards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('a.llp40__ready-details')) return;
        const presetKey = card.dataset.llp40Preset;
        const clickedToggle = event.target.closest('[data-llp40-preset-toggle]');
        const clickedSelect = event.target.closest('[data-llp40-preset-select]');
        const isActive = card.classList.contains('is-active');

        if (clickedToggle) {
          togglePreset(presetKey);
          return;
        }

        if (clickedSelect) {
          if (isActive) return;

          if (detailBundles[presetKey] && detailBundles[presetKey].selectSpecialPack) {
            selectSpecialPack(presetKey);
          } else {
            usePreset(presetKey);
          }
          return;
        }

        if (!event.target.closest('button')) {
          openDetail(presetKey);
        }
      });
    });

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-llp40-detail-close]')) {
        closeDetail();
        return;
      }

      if (event.target.closest('.llp40v2-detail__product a')) {
        rememberDetailOpen();
        return;
      }

      if (event.target.closest('[data-llp40-detail-next]')) {
        if (detailProducts) {
          const maxScroll = Math.max(0, detailProducts.scrollWidth - detailProducts.clientWidth);
          const firstCard = detailProducts.querySelector('.llp40v2-detail__product');
          const step = firstCard ? firstCard.getBoundingClientRect().width : detailProducts.clientWidth / 2;
          const nextLeft = Math.min(maxScroll, detailProducts.scrollLeft + step);

          detailProducts.scrollTo({
            left: nextLeft,
            behavior: 'smooth'
          });
          window.setTimeout(updateDetailNext, 260);
        }
        return;
      }

      if (event.target.closest('[data-llp40-detail-select]')) {
        const bundle = detailBundles[activeDetailKey];

        if (bundle && bundle.selectSpecialPack) {
          selectSpecialPack(bundle.selectSpecialPack);
        } else if (bundle && bundle.selectProduct) {
          addProduct(bundle.selectProduct);
        } else {
          usePreset(activeDetailKey);
        }

        closeDetail();
        return;
      }

      const removeButton = event.target.closest('[data-llp40-remove]');
      if (removeButton) {
        removeProduct(Number(removeButton.dataset.llp40Remove));
        return;
      }

      const productCheck = event.target.closest('[data-llp40-card-remove]');
      if (productCheck) {
        removeProductByKey(productCheck.dataset.llp40CardRemove);
        return;
      }

      const scrollButton = event.target.closest('[data-llp40-scroll-button]');
      if (scrollButton) {
        scrollAreaByButton(scrollButton);
        return;
      }

      if (event.target.closest('[data-llp40-change]')) {
        setTab('custom');
        scrollToOptions();
        return;
      }

      if (event.target.closest('[data-llp40-start-over]')) {
        const startOverButton = event.target.closest('[data-llp40-start-over]');
        if (startOverButton.disabled || startOverButton.classList.contains('is-disabled')) return;

        selected = [];
        activePreset = '';
        update();
        scrollToOptions();
        return;
      }

      const submitButton = event.target.closest('[data-llp40-submit], [data-llp40-sticky-submit]');
      if (submitButton) {
        if (isSubmittingCart) return;

        if (!isTravelKitSelected() && selected.length < getPackTarget()) {
          scrollToOptions();
          return;
        }

        updateForm();
        addCurrentSelectionToCart();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !detail || detail.hidden) return;
      closeDetail();
    });

    window.addEventListener('pageshow', restoreDetailIfNeeded);

    if (detailProducts) {
      detailProducts.addEventListener('scroll', updateDetailNext, { passive: true });
    }

    horizontalScrollers.forEach((scroller) => {
      scroller.addEventListener('scroll', updateScrollNav, { passive: true });

      scroller.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
        if (scroller.scrollWidth <= scroller.clientWidth) return;

        event.preventDefault();
        scroller.scrollLeft += event.deltaY;
        updateScrollNav();
      }, { passive: false });
    });

    window.addEventListener('resize', updateScrollNav);

    update();
    restoreDetailIfNeeded();
    window.requestAnimationFrame(updateScrollNav);
    window.setTimeout(updateScrollNav, 120);
  });
})();
